import { Button } from "@/components/ui/button";
import { useFlowValidator } from "@/hooks/use-flow-validator";
import { getFlowQuery } from "@/queries/flow.query";
import { FlowService } from "@/services/flow.service";
import { useQueryClient } from "@tanstack/react-query";
import { useParams } from "@tanstack/react-router";
import { ReactFlowInstance } from "@xyflow/react";
import { Save } from "lucide-react";
import { toast } from "sonner";

type SaveFlowButtonProps = {
  flowInstance: ReactFlowInstance | null;
}

export const SaveFlowButton = ({ flowInstance }: SaveFlowButtonProps) => {
  const queryClient = useQueryClient();
  const params = useParams({ from: '/_authenticated/flows/$id/edit' });

  const [isValidating, validateFlow] = useFlowValidator((isValid, result) => {
    if (isValid) {
      if (!flowInstance) return;
      const workflow = flowInstance.toObject();
      FlowService.update(+params.id, {
        workflow: {
          nodes: workflow.nodes,
          edges: workflow.edges,
        }
      }).then(() => {
        toast.success("Fluxo salvo", {
          description: "Você pode agora prosseguir para o próximo passo",
          dismissible: true,
        });
      }).catch(() => {
        toast.error("Falha ao salvar Fluxo", {
          description: "Ocorreu um erro ao tentar salvar o workflow verifique os dados e tente novamente mais tarde",
          dismissible: true,
        });
      }).finally(() => {
        queryClient.invalidateQueries(getFlowQuery(+params.id))
      })
    } else {
      if (result) {
        const totalErrors = result.errors.length + result.nodeErrors.length;
        toast.error("Fluxo inválido", {
          description: `${totalErrors} erro${totalErrors !== 1 ? 's' : ''} encontrado${totalErrors !== 1 ? 's' : ''}. Verifique o painel de erros para mais detalhes.`,
          dismissible: true,
          duration: 5000,
        });
      } else {
        toast.error("Fluxo inválido", {
          description: "Por favor, verifique se o fluxo está completo e não possui nós soltos",
          dismissible: true,
        });
      }
    }
  });

  return (
    <Button
      onClick={validateFlow}
      disabled={isValidating}
      variant={"outline"}
      size={"sm"}
      className="flex gap-4"
    >
      <Save className="size-4 mr-4" />
      Salvar Fluxo
    </Button>
  );
};
